function SvgComponent({ fillColor = '#1FCDFF', color = 'white', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="8" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7945 6.1664C15.8307 5.51608 14.1417 6.89615 13.7478 8.15909C13.7478 8.15909 12.3307 12.71 11.7269 14.6084C11.4387 15.5145 10.7245 16.9969 9.37941 16.9969C8.28411 16.9969 7.7213 15.9689 7.48366 15.3563L5.85047 11.0027C5.6613 10.5443 5.85922 9.62937 6.61792 9.35537C7.42846 9.06455 7.94952 9.74247 8.08416 10.1026L10.1186 15.3132C10.6033 14.6885 10.9116 13.672 11.1122 12.9523L9.7766 9.44491C9.14312 7.80835 7.46751 7.06378 5.91577 7.636C4.65889 8.09917 3.44914 9.68524 4.10686 11.6786L5.79257 16.014C6.04839 16.6711 7.05887 18.8166 9.34373 18.8166C12.0857 18.8166 13.1144 16.4786 13.6852 14.6306C13.9707 13.7063 15.5359 8.70842 15.5359 8.70842C15.7634 7.96184 16.6871 7.74708 17.2647 7.93558C17.672 8.06753 18.4078 8.62966 18.1701 9.50078C18.1257 9.65966 16.8776 13.6807 16.4171 14.9039C16.1768 15.5421 15.5675 16.9276 14.1794 16.7351C13.7566 17.6708 13.4052 18.2154 12.8733 18.7042C14.6048 19.5241 17.128 18.6981 18.1903 15.4889C18.5848 14.2954 19.9703 9.99155 19.9703 9.99155C20.3729 8.67005 19.6545 6.78171 17.7945 6.1664Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgComponent;
